/**
 * Created by: cparaschiv
 * Date: 25.11.2013, 09:04
 */

(function (factory) {

    factory(
        window.jQuery
    );

}(function ($) {

    var parentWidget = $.blueimp.fileupload;

    var spinnerCfg = {
        lines: 10,
        length: 4,
        width: 2,
        radius: 3,
        trail: 30,
        speed: 1.0,
        left: -3,
        top: 1
    };

    $.widget('TS.fileupload', parentWidget, {

        options: {
            autoUpload: true
        },

        _create: function () {
            var me = this,
                propName = me.options.propName,
                $elem = me.element,
                $fileInput,
                fileName, fileId,
                url;

            parentWidget.prototype._create.call(this);

            me.$progressBar = $elem.find('.upload-progress-bar').first();
            me.$dragOverHint = $elem.find('.drag-over-hint').first();
            me.$spinner = $elem.find('.upload-spinner').first();
            me.$btnSelectFile = $elem.find('.btn-select-file').first();
            me.$btnCancel = $elem.find('.btn-cancel-upload').first();
            me.$filenameSpan = $elem.find('.filename').first();

            $fileInput = $elem.find('input');
            this.options.url = $fileInput.attr('data-url');

            me.$btnCancel.click($.proxy(me._cancelUpload, me));
            me.$dragOverHint.html(TS.cultures.current.fileUploadMessages.DragOverHint);

            if (me.options.domainProp) {
                fileName = TS.unwrap(me.options.domainProp.Value());
                fileId = me.options.domainProp.FileId;
                if (fileId) {
                    url = me._getDownloadUrl(me.options.domainProp.FileId);
                    me._setLink(fileName, url);
                } else {
                    me._setLabel(fileName);
                }
            }
        },

        _logEvent: function(msg, e){
            function getPhase(p) {
                if (p == 1)
                    return 'CAPTURING_PHASE';
                if (p == 2)
                    return 'AT_TARGET';
                if (p == 3)
                    return 'BUBBLING_PHASE';
            }
            console.log(msg + ' target: ' + e.target + ', phase: ' + getPhase(e.eventPhase));
        },

        _initEventHandlers: function () {
            parentWidget.prototype._initEventHandlers.call(this);

            if (this._isXHRUpload(this.options)) {
                this._off(this.options.dropZone, 'dragover drop');
                this._on(this.options.dropZone, {
                    dragover: this._onDragOver,
                    drop: this._onDrop,
                    dragleave: this._onDragLeave
                });
            }
        },

        _getModelUID: function(){
            var me = this;
            return TS.unwrap(me.options.domainProp.Domain().modelUID);
        },

        _initXHRData: function(options){
            var me = this;
            parentWidget.prototype._initXHRData.call(this, options);

            options.headers['FileUploadProperty'] = me.options.propName;
            options.headers['ModelUID'] = me._getModelUID();
        },

        _initIframeSettings: function(options){
            var me = this;
            parentWidget.prototype._initIframeSettings.call(this, options);

            // fallback in case we use the iframe to post files
            options.formData.push({ name: 'FileUploadProperty', value: me.options.propName });
            options.formData.push({ name: 'ModelUID', value: me._getModelUID() });
        },

        _destroyEventHandlers: function () {
            parentWidget.prototype._destroyEventHandlers.call(this);

            this._off(this.options.dropZone, 'dragleave');
        },

        _setLabel: function(content) {
            this.$filenameSpan.html(content);
        },

        _setLink: function(text, url){
            var me = this,
                html = '<a href="' + url + '">' + text + '</a>';

            me._setLabel(html);
        },

        _setDisplayError: function(message){
            var me = this,
                html = '<span class="upload-error">' + message + '</span>';
            me._setLabel(html);
        },

        _setProgressBar: function(percent) {
            this.$progressBar.css('width', percent + '%');
        },

        _reset: function(){
            var me = this;

            //me.$spinner.spin(false);
            //me.$btnSelectFile.spin(false);
            me._setProgressBar(0);
            me._setLabel('');

            me.element.toggleClass('over', false);
            me.$btnSelectFile.show();
            me.$btnCancel.hide();

            me.element.find('.upload-status').css('border', 'none');
        },

        _onDragOver: function(e, data){
            var me = this;

            me._logEvent('OVER', e);
            parentWidget.prototype._onDragOver.apply(this, arguments);

            me.element.toggleClass('over', true);
        },

        _onDragLeave: function(e, data){
            var me = this;
            me._logEvent('LEAVE', e);

            me.element.toggleClass('over', false);
        },

        _onAdd: function(e, data){
            var me = this,
                ret,
                file = data.files[0];

            ret = parentWidget.prototype._onAdd.apply(this, arguments);

            me.element.toggleClass('over', false);

            me.$btnSelectFile.hide();
            me.$btnCancel.show();
            me.$progressBar.show();
            me.$spinner.show();
            me.$spinner.spin(spinnerCfg);

            me._setLabel(file.name + ' (' + TS.Util.formatBytes(file.size) + ')')

            return ret;
        },

        _onSend: function(e, data){
            var me = this,
                ret;

            ret = parentWidget.prototype._onSend.apply(this, arguments);

            me.element.find('.upload-status').css('border', '1px dotted #d3d3d3');

            // store it for aborting in _cancelUpload
            me._jqXHR = ret;

            return ret;
        },

        _cancelUpload: function (e) {
            var me = this,
                data = me._currentData;

            e.preventDefault();

            if (me._jqXHR)
                me._jqXHR.abort();
        },

        _getDownloadUrl: function(fileID){
            var me = this,
                url, params;

            params = {
                file: fileID,
                modelUID: me._getModelUID(),
                propName: me.options.propName
            };

            url = me.options.url + '?' + $.param(params);

            return url;
        },

        _onDone: function(result, textStatus, jqXHR, options){
            var me = this,
                ret,
                resp,
                tpl,
                url,
                params;

            ret = parentWidget.prototype._onDone.apply(this, arguments);

            // result is from an iframe (ie9 and lower fallback)
            if (typeof result == 'object') {
                result = result.find('body').text();
                if (!result)
                    return ret;
            }

            if (typeof result === 'string'){
                me._reset();
                resp = JSON.parse(result)[0];

                if (resp.error) {
                    me._setDisplayError(resp.error);
                    return ret;
                }

                url = me._getDownloadUrl(resp.id);
//                tpl = '<a href="' + url + '">' + resp.fileName + ' (' + TS.Util.formatBytes(resp.size) + ')' + '</a>';
//                me._setLabel(tpl);
                me._setLink(resp.fileName, url);
            }

            return ret;
        },

        _onFail: function(jqXHR, textStatus, errorThrown, options){
            var me = this,
                ret,
                text,
                html;

            ret = parentWidget.prototype._onFail.apply(this, arguments);

            me._reset();

            if (errorThrown == 'abort') {
                text = TS.cultures.current.fileUploadMessages.UploadCancelled;
            } else {
                text = TS.cultures.current.fileUploadMessages.Error + ': ' + errorThrown;
            }
            me._setDisplayError(text);

            return ret;
        },

        _onProgress: function(e, data){
            var me = this,
                ret,
                progress = parseInt(data.loaded / data.total * 100, 10);

            ret = parentWidget.prototype._onProgress.apply(this, arguments);

            me._setProgressBar(progress);

            return ret;
        }

    });

    ko.bindingHandlers['tsFileUpload'] = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {

            var propName = TS.unwrap(valueAccessor()),
                $elem = $(element),
                domainProp,
                widget;

            domainProp = viewModel.getDomainProperty(propName);
            widget = $elem.fileupload({
                propName: propName,
                domainProp: domainProp,
                dropZone: element
            });
        }
    };

}));